import React from 'react';
import { connect } from 'react-redux';
import properties from '../../modules/ajio-util/properties';
import getChannelType from '../../utils/getChannelType';
import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

class Loader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      announceMsg: false
    };

    this.timeoutRef = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      clearTimeout(this.timeoutRef);

      this.setState({ announceMsg: true });

      this.timeoutRef = setTimeout(() => {
        this.setState({ announceMsg: false });
      }, 1000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutRef);
  }

  render() {
    const { show = false, defaultIcon = true, className = '', newDesignLuxe } = this.props;
    const device = getChannelType();

    const url =
      device === 'MSITE' || newDesignLuxe
        ? `${imageBaseUrl}/static/img/refreshsitespinner_2.gif`
        : `${imageBaseUrl}/static/img/sitespinner.gif`;

    return (
      <>
        <span className="sr-only" aria-live="polite">
          {this.state.announceMsg ? 'Loading' : ''}
        </span>

        {show ? (
          <div className={`loader ${className}`}>
            {defaultIcon ? <img src={url} alt="Ajio loader" /> : null}
            {this.props.children}
          </div>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loaders = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const { name, forceShow = false } = ownProps;
  let show = false;
  if (loaders[name] || forceShow) {
    show = true;
  }
  return {
    show,
    newDesignLuxe
  };
};

export default connect(mapStateToProps)(Loader);
